import React from "react";

const PoliticaCookies = () => (
  <div className="document-container">
    <div className="politica-cookies">
      <h1>Política de Cookies</h1>
      <p>
        Esta Política de Cookies explica cómo nuestra web utiliza cookies y
        tecnologías similares para mejorar su experiencia en nuestro sitio. Al
        acceder y utilizar este sitio web, acepta el uso de cookies de acuerdo
        con esta Política.
      </p>
      <h2>¿Qué son las Cookies?</h2>
      <p>
        Las cookies son pequeños archivos de texto que se almacenan en su
        dispositivo (ordenador, tablet o teléfono) al visitar ciertos sitios web.
        Su función es permitir que el sitio web recuerde sus preferencias, como
        el idioma o la configuración de privacidad, y pueda ofrecerle una
        experiencia de navegación más personalizada.
      </p>
      <h2>¿Qué tipos de Cookies usamos?</h2>
      <ul>
        <li>
          <strong>Cookies necesarias</strong>: Estas cookies son esenciales para
          el funcionamiento de nuestro sitio web y permiten la navegación a
          través de las secciones del mismo. Sin estas cookies, el sitio no puede
          funcionar adecuadamente.
        </li>
        <li>
          <strong>Cookies de análisis</strong>: Nos ayudan a entender cómo los
          usuarios interactúan con nuestro sitio, recopilando y reportando
          información de forma anónima. Esto nos permite mejorar la funcionalidad
          y contenido del sitio.
        </li>
        <li>
          <strong>Cookies de personalización</strong>: Almacenan sus preferencias
          personales, como el idioma o la región desde la que accede.
        </li>
        <li>
          <strong>Cookies publicitarias</strong>: Utilizadas para mostrar
          anuncios relevantes y personalizados según su comportamiento de
          navegación.
        </li>
      </ul>
      <h2>Cómo gestionar las Cookies</h2>
      <p>
        Puede configurar su navegador para aceptar o rechazar todas las cookies o
        para que le avise cuando se envíe una cookie. Consulte las opciones de
        configuración de su navegador para gestionar sus preferencias.
      </p>
    </div>
  </div>
);

export default PoliticaCookies;
